import ApiService from "../../../services/ApiService";

const BASE = "/v1/speed-rank";

function buildSort(sort) {
    if (!Array.isArray(sort) || sort.length === 0) return "bestSeconds:asc";
    return sort.map((s) => `${s.field}:${s.sort}`).join(",");
}

function totalElements(result) {
    if (!result || typeof result !== "object") return 0;
    return result.totalElements ?? result.page?.totalElements ?? 0;
}

const SpeedRankService = {
    list: async (paginationModel, sort, {
        keyword = "",
        puzzleType = "",
        modeKey = "",
        testFilter = "all",
    } = {}) => {
        const params = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            sort: buildSort(sort),
            testFilter: testFilter === "testers" || testFilter === "exclude" ? testFilter : "all",
        };
        if (keyword) params.keyword = keyword;
        if (puzzleType) params.puzzleType = puzzleType;
        if (modeKey) params.modeKey = modeKey;
        return ApiService.getData(BASE, params);
    },

    remove: async (id) => {
        return ApiService.deleteData(`${BASE}/${id}`);
    },

    /**
     * GET /v1/speed-rank/modes?puzzleType=&testFilter=&limit=
     * Catalog modes with top speeds for the Puzzle tab.
     */
    listModes: async ({ puzzleType, testFilter = "exclude", limit = 5 } = {}) => {
        const type = puzzleType ? String(puzzleType).trim() : "";
        if (!type) {
            return { error: "puzzleType required" };
        }
        const params = {
            puzzleType: type,
            limit,
            testFilter: testFilter === "testers" || testFilter === "exclude" ? testFilter : "all",
        };
        return ApiService.getData(`${BASE}/modes`, params);
    },

    /**
     * POST /v1/speed-rank/sync-from-plays?puzzleType=JIGSAW|SLIDING
     */
    syncFromPlays: async (puzzleType) => {
        const type = puzzleType ? String(puzzleType).trim() : "";
        if (!type) {
            return { error: "puzzleType required" };
        }
        return ApiService.postData(
            `${BASE}/sync-from-plays?puzzleType=${encodeURIComponent(type)}`,
            {},
        );
    },

    /**
     * POST /v1/speed-rank/seed-sliding-testers
     * 10 SlideBot testers × all sliding modes + matching score board.
     */
    seedSlidingTesters: async () => {
        return ApiService.postData(`${BASE}/seed-sliding-testers`, {});
    },

    /**
     * DELETE /v1/speed-rank/testers — remove all test-account speed PBs.
     */
    removeAllTesters: async () => {
        return ApiService.deleteData(`${BASE}/testers`);
    },

    totalElements,
};

export default SpeedRankService;
